export default __webpack_public_path__ + "static/media/21-ART-(4-2).0505e36a.jpg";